import React from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import ReactModal from "react-modal";
import { HInput } from "../../../validation/HForm";
import CrossIcon from "../../../assets/icons/cross.svg";
import { baseValueSchema } from "../debtToIncomeRatioShcema";
import { debtHandbookFields, modalTitles, renderValueWithUnit } from "../helpers";
import "../index.scss";

const BaseValueModal = ({ onSubmit, onClose, defaultValues }) => {
  const form = useForm({
    defaultValues: defaultValues,
    resolver: joiResolver(baseValueSchema),
  });

  const { fields } = useFieldArray({
    control: form.control,
    name: "values",
    keyName: "_id",
  });

  const handleFormSubmit = async (data) => {
    if (onSubmit) {
      const formattedData = {
        name: debtHandbookFields.BASE_VALUES,
        values: data.values,
      };
      await onSubmit(formattedData);
    }
  };

  return (
    <ReactModal
      isOpen={true}
      contentLabel="Modal"
      className="modal-container"
      overlayClassName="modal-overlay"
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleFormSubmit)}>
          <div className="modal-header">
            <h2>{modalTitles[debtHandbookFields.BASE_VALUES]}</h2>
            <button
              className="button-icontrigger modal-closetrigger"
              onClick={onClose}
            >
              <span className="icon">
                <CrossIcon />
              </span>
            </button>
          </div>
          <div className="modal-body modal-body__height debt-modal">
            <fieldset>
              {fields.map((field, index) => {
                return (
                  <div
                    key={index}
                    className="form-element inline flex-space-between"
                  >
                    <HInput
                      type="hidden"
                      name={`values.${index}.id`}
                      value={field.id}
                    />
                    <HInput
                      type="hidden"
                      name={`values.${index}.name`}
                      value={field.name}
                    />
                    <label
                      className="form-element-label handbook-label"
                      htmlFor="baseValueEdit"
                    >
                      {field.name}
                    </label>
                    <div className="form-element-data number align-end">
                      <HInput
                        className="input"
                        h="true"
                        type="text"
                        autoComplete="off"
                        name={`values.${index}.value`}
                        defaultValue={field.value.toFixed(2)}
                        placeholder={field.dataType}
                        decimals={2}
                      />
                    </div>
                  </div>
                );
              })}
            </fieldset>
          </div>
          <div className="modal-footer">
            <button type="submit" className="button">
              Сохранить
            </button>
            <button className="button-light" onClick={onClose}>
              Отменить
            </button>
          </div>
        </form>
      </FormProvider>
    </ReactModal>
  );
};

export default BaseValueModal;
